import { GetOrg } from 'domain/usecases/org/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetOrg implements GetOrg {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetOrg.Model>;

  constructor(url: string, httClient: HttpClient<GetOrg.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (params: GetOrg.Params): Promise<GetOrg.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{orgId}', `${params.id}`),
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
      case HttpStatusCode.notModified:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
